import type { SignalFilterProps } from './signal-filter.interface';
import { useSignals } from '@preact/signals-react/runtime';
import { createElement, Fragment } from 'react';

/**
 * Takes a signal with an array of items and filters them out returning only the remaining items.
 * @param {Signal<Array<T>>} value - A signal containing an array of items to be filtered.
 * @param {(item: T) => boolean} filter - The filter function used to determine what to return.
 * @param {React.JSX.Element} fallback - The element to return when the filter returns no results.
 * @param {(items: Array<T>) => React.JSX.Element} children - The child render function called with the results.
 * @constructor
 */
const SignalFilter = <T,>({ value, filter, fallback, children }: SignalFilterProps<T>) => {
  useSignals();

  const list = value.value.filter(filter);

  if (!list.length) return fallback || null;

  return createElement(Fragment, undefined, children(list));
};

export { SignalFilter };
